import { EventEmitter } from 'events';
import {
  BitfinexTradeData,
  BitflyerTradeData,
  BitmexTradeData,
  AlertData,
} from '@/types/trade';
import { Bitfinex } from './bitfinex';
import { Bitflyer } from './bitflyer';
import { Bitmex } from './bitmex';
import { TradesService } from './trades';
export class MarketDataProvider extends EventEmitter {
  private bitfinexDataProvider = new Bitfinex();
  private bitflyerDataProvider = new Bitflyer();
  private bitmexDataProvider = new Bitmex();
  private tradesService = new TradesService();
  private alertHistoryQueue: AlertData[] = [];
  get bitfinex() {
    return this.bitfinexDataProvider;
  }
  get bitflyer() {
    return this.bitflyerDataProvider;
  }
  get bitmex() {
    return this.bitmexDataProvider;
  }
  constructor() {
    super();
    this.bitfinex.on('trades', (data: BitfinexTradeData) => {
      this.tradesService.addBitfinexTrade(data);
      this.emit('trades', this.tradesService.getExchangeTrades());
    });
    this.bitflyer.on('executions', (data: BitflyerTradeData[]) => {
      data.forEach((v) => {
        this.tradesService.addBitflyerTrade(v);
      });
      this.emit('trades', this.tradesService.getExchangeTrades());
    });
    this.bitmex.on('trade', (data: BitmexTradeData[]) => {
      data.forEach((v) => {
        this.tradesService.addBitmexTrade(v);
      });
      this.emit('trades', this.tradesService.getExchangeTrades());
    });
    this.tradesService.on('alert', (alertData: AlertData) => {
      this.alertHistoryQueue.push(alertData);
      this.emit('alert');
    });
  }
  public dequeueAlertData() {
    const alertHistory = this.alertHistoryQueue;
    this.alertHistoryQueue = [];
    return alertHistory;
  }
}
